import Input from "components/v2/Input/Input";
import Filter from "components/v2/Filters/Filter";
import useConsolidatedShipmentFilters from "hooks/filters/useConsolidatedShipmentFilters";
import { ReactComponent as SearchIcon } from "assets/images/iconsV2/Search.svg";
import DateFilter from "./DateFilter";
import "./FilterRow.scss";

type FilterRowProps = {
  data: any;
  currentFilters: Record<string, any>;
  setCurrentFilters: Function;
  searchInput: string;
  setSearchInput: Function;
  timeFrame: number;
  setTimeFrame: Function;
};

type Option = {
  label: string;
  value: string;
};

type UniqueLocations = {
  origin: {
    pickup_city: Option[];
    pickup_address: Option[];
  };
  destination: {
    stop1_city: Option[];
    stop1_address: Option[];
  };
};

type Order = {
  reference_number: string;
  title: string;
  total_weight_kg: string;
  total_cbm: string;
  dangerous_good: boolean;
  temperature_controlled: boolean;
  pickup_start_date: string;
  pickup_end_date: string | null;
  delivery_start_date: string;
  delivery_end_date: string | null;
  payment_location: string;
  created_by: string;
};

type ConsolidatedOrder = {
  pickup_address: string;
  pickup_city: string;
  pickup_reference_number: string;
  delivery_address: string;
  delivery_city: string;
  delivery_reference_number: string;
  count: number;
  orders: Order[];
};

function FilterRow({
  data,
  currentFilters,
  setCurrentFilters,
  searchInput,
  setSearchInput,
  timeFrame,
  setTimeFrame,
}: FilterRowProps) {
  // Function to get all unique addresses and cities, sorted by origin and destination, in order to fill filter options
  function getUniqueLocations(orderData: ConsolidatedOrder[]): UniqueLocations {
    const uniquePickupCities: Set<string> = new Set();
    const uniquePickupAddresses: Set<string> = new Set();
    const uniqueDeliveryCities: Set<string> = new Set();
    const uniqueDeliveryAddresses: Set<string> = new Set();

    orderData.forEach((item) => {
      uniquePickupCities.add(item.pickup_city);
      uniquePickupAddresses.add(item.pickup_address);
      uniqueDeliveryCities.add(item.delivery_city);
      uniqueDeliveryAddresses.add(item.delivery_address);
    });

    const formatOptions = (set: Set<string>): Option[] => Array.from(set).map((value) => ({ label: value, value }));

    return {
      origin: {
        pickup_city: formatOptions(uniquePickupCities),
        pickup_address: formatOptions(uniquePickupAddresses),
      },
      destination: {
        stop1_city: formatOptions(uniqueDeliveryCities),
        stop1_address: formatOptions(uniqueDeliveryAddresses),
      },
    };
  }

  const { config: consolidatedFilterConfig } = useConsolidatedShipmentFilters(getUniqueLocations(data));

  return (
    <div className="d-flex justify-content-between">
      <Input
        icon={<SearchIcon />}
        value={searchInput}
        placeholder="Search for an origin, destination, or order number"
        onChange={(e) => setSearchInput(e.target.value)}
        width="488px"
      />
      <div className="d-flex">
        <DateFilter timeFrame={timeFrame} setTimeFrame={setTimeFrame} />

        <Filter
          eventContext="Consolidated Shipment List"
          currentFilters={currentFilters}
          setCurrentFilters={setCurrentFilters}
          config={consolidatedFilterConfig}
        />
      </div>
    </div>
  );
}

export default FilterRow;
